import React from "react";
import styled from "styled-components";
import { getWord } from "@stores/vars";

const Wrap = styled.div`
  position: absolute;
  opacity: 0;
  width: 520px;
  height: 140px;
  left: 18px;
  top: 73px;
`;

const DropItem = ({ data, isClear, categoryKey }) => {
  const word = getWord(data.word, categoryKey);
  return (
    <Wrap
      className={isClear ? "c-holder isclear" : "c-holder"}
      data-name={word}
    ></Wrap>
  );
};

export default DropItem;
